import { Component } from "react";
import { typography, radius, spacing } from "../styles/tokens";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", fontFamily: typography.fontFamily, background: "var(--khv-bg)" }}>
        <div style={{ textAlign: "center", maxWidth: 420, padding: spacing.xxxl }}>
          <div style={{ fontSize: typography.sizes.xxl, fontWeight: typography.weights.extrabold, color: "var(--khv-text-primary)", marginBottom: spacing.md }}>Something went wrong</div>
          <p style={{ fontSize: typography.sizes.base, color: "var(--khv-text-secondary)", marginBottom: spacing.xxl }}>
            {this.props.label ? `An error occurred in ${this.props.label}.` : "An unexpected error occurred."} Please try refreshing the page.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: `${spacing.sm}px 18px`, borderRadius: radius.md, fontSize: typography.sizes.base, fontWeight: typography.weights.bold, fontFamily: typography.fontFamily, cursor: "pointer", border: "1px solid var(--khv-accent)", background: "var(--khv-accent)", color: "var(--khv-text-inverse)" }}
          >Refresh Page</button>
        </div>
      </div>
    );
  }
}
